import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class NextStepActionCard extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      isCompleted: !!this.props.isCompleted
    };

    this.handleLinkClick = this.handleLinkClick.bind(this);
  }

  handleLinkClick () {
    this.props.handleLinkClick();
    this.setState({ isCompleted: true });
  }

  render () {
    const { isCompleted } = this.state;
    const { svgSrc = '', headingText = '', bodyText = '', linkText = '', linkTo = '#' } = this.props;
    const className = classnames('NextStepActionCard flex margin-xl-bottom', { completed: isCompleted });

    return (
      <div className={className}>
        <div className="flex center">
          { isCompleted ?
            <img className="cardImg" src="/web-hosting/assets/images/circle-check-green.svg?v=rb" alt="peerspace" /> :
            <img className="cardImg" src={svgSrc} alt="peerspace" />
          }
        </div>

        <div className="flex column center info">
          <h6 className="no-top-margin margin-sm-bottom title">{headingText}</h6>
          <span className="text-gray-600 padding-md-bottom">{bodyText}</span>
        </div>

        <div className="linkContainer flex middle center actionButton">
          <a href={linkTo} target="_blank" rel="noopener noreferrer" className="btn btn-default btn-outlined-light" onClick={this.handleLinkClick}>{linkText}</a>
        </div>
      </div>
    );
  }
}


NextStepActionCard.propTypes = {
  isCompleted: PropTypes.bool,
  svgSrc: PropTypes.string,
  headingText: PropTypes.string,
  bodyText: PropTypes.string,
  linkText: PropTypes.string,
  linkTo: PropTypes.string,
  handleLinkClick: PropTypes.func
};

export default NextStepActionCard;
